<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <el-container style="height:100%;width:100%">
      <el-header style="line-height:60px;padding:0px">
        <el-row>
          <el-col :span="24">
            <el-button-group>
              <el-button
                class="btn-primary"
                size="small"
                style="width:120px"
                @click="getStaffWeekSchedule(2)"
              >上一周</el-button>
              <el-button
                class="btn-primary"
                size="small"
                style="width:120px"
                @click="getStaffWeekSchedule(1)"
              >本周</el-button>
              <el-button
                class="btn-primary"
                size="small"
                style="width:120px"
                @click="getStaffWeekSchedule(3)"
              >下一周</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-header>
      <el-container style="height:100%">
        <el-main width="100%" height="100%" style="padding:0px;">
          <el-table
            :data="myWorkTimeData"
            :span-method="cellMerge"
            border
            fix
            height="600"
            style="width:100%"
            :header-cell-style="{background:'#F2F6FC',align:'center'}"
          >
            <el-table-column
              align="center"
              type="index"
              :index="indexMethod"
              label="周期/时间"
              width="220px"
            ></el-table-column>
            <el-table-column header-align="center" label="0" width="60px">
              <template slot-scope="scope">
                <div :key="index" v-for="(item,index) in scope.row.Times">
                  <el-popover
                    placement="top-start"
                    :title="item.Name"
                    width="200"
                    trigger="hover"
                    :content="item.SpanText"
                  >
                    <el-tag
                      slot="reference"
                      :style="getTagStyle(item)"
                      size="medium"
                      :color="tagColor(item)"
                    >{{getTagValue(item)}}</el-tag>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column header-align="center" label="1" width="60px"></el-table-column>
            <el-table-column header-align="center" label="2" width="60px"></el-table-column>
            <el-table-column header-align="center" label="3" width="60px"></el-table-column>
            <el-table-column header-align="center" label="4" width="60px"></el-table-column>
            <el-table-column header-align="center" label="5" width="60px"></el-table-column>
            <el-table-column header-align="center" label="6" width="60px"></el-table-column>
            <el-table-column header-align="center" label="7" width="60px"></el-table-column>
            <el-table-column header-align="center" label="8" width="60px"></el-table-column>
            <el-table-column header-align="center" label="9" width="60px"></el-table-column>
            <el-table-column header-align="center" label="10" width="60px"></el-table-column>
            <el-table-column header-align="center" label="11" width="60px"></el-table-column>
            <el-table-column header-align="center" label="12" width="60px"></el-table-column>
            <el-table-column header-align="center" label="13" width="60px"></el-table-column>
            <el-table-column header-align="center" label="14" width="60px"></el-table-column>
            <el-table-column header-align="center" label="15" width="60px"></el-table-column>
            <el-table-column header-align="center" label="16" width="60px"></el-table-column>
            <el-table-column header-align="center" label="17" width="60px"></el-table-column>
            <el-table-column header-align="center" label="18" width="60px"></el-table-column>
            <el-table-column header-align="center" label="19" width="60px"></el-table-column>
            <el-table-column header-align="center" label="20" width="60px"></el-table-column>
            <el-table-column header-align="center" label="21" width="60px"></el-table-column>
            <el-table-column header-align="center" label="22" width="60px"></el-table-column>
            <el-table-column header-align="center" label="23" width="60px"></el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "",
  components: {
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      nowDate: new Date(),
      weekDate: null,
      lastWeek: null,
      nextWeek: new Date(),
      dateStr: "",
      myWorkTimeData: [
        // "data":[
        // {
        //     "DateTime":"2020-04-01",
        //     "TimeSetName":"默认",
        //     "IsTemp":false,
        //     "Times":[
        //         {
        //             "SetId":"1511138a-acf0-4edf-abe0-58dd16637900",
        //             "Sort":7,
        //             "Name":"正常",
        //             "OnDutyHour":9,
        //             "OnDutyMinute":30,
        //             "OffDutyHour":18,
        //             "OffDutyMinute":0,
        //             "OnDutyTime":"09:30",
        //             "OffDutyTime":"18:00"
        //         }
        //     ]
        // },
      ],
      weekday: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ],
      lastWeekEndData: null,
      lastColor: "",
      tagColor(item) {
        let r = Math.floor(Math.random() * 256);
        let g = Math.floor(Math.random() * 256);
        let b = Math.floor(Math.random() * 256);
        let color = "#" + r.toString(16) + g.toString(16) + b.toString(16);
        if (item.OffDutyTime.search("次日") > -1) {
          switch (item.part) {
            case 1:
              this.lastColor = color;
              break;
            case 2:
              color = this.lastColor;
              break;
          }
        }
        return color;
      },
      getTagStyle(item) {
        let style = "position:relative;left:-10px;text-align:center;";
        let width =
          item.SpanCount * 60 - item.OnDutyMinute + item.OffDutyMinute;
        let marginLeft = item.OnDutyHour * 60 + item.OnDutyMinute;
        style += "width:" + width + "px;margin-left:" + marginLeft + "px;";
        return style;
      },
      getTagValue(item) {
        let text = item.SpanText;
        let width =
          item.SpanCount * 60 - item.OnDutyMinute + item.OffDutyMinute;
        let maxLen = width / 10;
        let len = item.SpanText.length;
        if (len >= maxLen) {
          let sublen = maxLen - len;
          text = item.SpanText.slice(0, sublen) + "...";
        }
        return text;
      }
    };
  },
  created() {
    this.getStaffWeekSchedule(1);
  },
  mounted() {},
  methods: {
    //table合并列
    //rowIndex 行,column 列(+1)
    cellMerge({ row, column, rowIndex, columnIndex }) {
      //跳过第一列
      if (columnIndex == 0) {
        return;
      }
      if (columnIndex == 1) {
        return {
          rowspan: 1,
          colspan: 24
        };
      }
    },
    //获取本周的第一天日期
    getWeekStartDate() {
      let year = this.nowDate.getFullYear();
      let month = this.nowDate.getMonth()+1;
      let strDate = this.nowDate.getDate();
      this.today = this.nowDate.getDay();
      let weekStartDate = new Date(year, month, strDate - this.today);
      let sd = weekStartDate.getDate();
      this.weekDate = weekStartDate;
      return this.getFormatDate(year, month, sd);
    },
    //获取上一周
    getLastWeekFormatDate() {
      this.lastWeek = new Date(this.weekDate - 7 * 24 * 3600 * 1000);
      let year = this.lastWeek.getFullYear();
      let month = this.lastWeek.getMonth() + 1;
      let strDate = this.lastWeek.getDate();
      this.weekDate = this.lastWeek;
      return this.getFormatDate(year, month, strDate);
    },
    //获取下一周
    getNextWeekFormatDate() {
      this.nextWeek.setFullYear(this.weekDate.getFullYear());
      this.nextWeek.setMonth(this.weekDate.getMonth());
      this.nextWeek.setDate(this.weekDate.getDate() + 7);
      let year = this.nextWeek.getFullYear();
      let month = this.nextWeek.getMonth() + 1;
      let strDate = this.nextWeek.getDate();
      this.weekDate = this.nextWeek;
      return this.getFormatDate(year, month, strDate);
    },
    //格式化时间格式参数
    getFormatDate(year, month, strDate) {
      let seperator1 = "-";
      if (month < 10) {
        month = "0" + month;
      }
      if (strDate < 10) {
        strDate = "0" + strDate;
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    //自定义索引
    indexMethod(index) {
      let day = this.weekday[index];
      let date = this.myWorkTimeData[index].DateTime;
      return day + " " + date;
    },
    analyzeWorkTimeDate(timesData) {
      let timeData = timesData;
      let spanCount = 0;

      //上班的时长
      if (timeData.OffDutyHour < timeData.OnDutyHour) {
        spanCount = 24 - timeData.OnDutyHour;
      } else if (timeData.OnDutyHour - timeData.OffDutyHour == 0) {
        spanCount = 24;
      } else {
        spanCount = timeData.OffDutyHour - timeData.OnDutyHour;
      }

      // //合并的列数
      timeData.SpanCount = spanCount;

      //展示的文本
      timeData.SpanText =
        timeData.Name +
        "(" +
        timeData.OnDutyTime +
        "~" +
        timeData.OffDutyTime +
        ")";

      return timeData;
    },
    //获取时段选择列表
    getStaffWeekSchedule(type) {
      let that = this;

      switch (type) {
        case 1:
          this.dateStr = this.getWeekStartDate();
          break;
        case 2:
          this.dateStr = this.getLastWeekFormatDate();
          break;
        case 3:
          this.dateStr = this.getNextWeekFormatDate();
          break;
      }

      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/getStaffWeekSchedule",
          data: {
            entpId: this.userMsg.EntpId,
            staffId: this.userMsg.EmployeeId,
            startTime: this.dateStr
          }
        })
        .then(res => {
          that.myWorkTimeData = [];
          if (res.data) {
            let lastSATday = res.data.shift();
            let temp = lastSATday.Times.find(item => {
              return item.OffDutyTime.indexOf("次日") > -1;
            });

            that.myWorkTimeData = res.data;
            that.myWorkTimeData[0].Times.push(temp);
            for (let i = 0; i < that.myWorkTimeData.length; i++) {
              let WorkTimeData = that.myWorkTimeData[i];
              if (i == 0) {
                //处理周六的跨日班次
                let len = WorkTimeData.Times.length;
                let lastDay = WorkTimeData.Times[len - 1];
                if (lastDay.Sort == 6) {
                  lastDay = that.analyzeWorkTimeDate(lastDay);
                  lastDay.OnDutyHour = 0;
                }
              }
              for (let j = 0; j < WorkTimeData.Times.length; j++) {
                let element = WorkTimeData.Times[j];
                element = that.analyzeWorkTimeDate(element);

                if (
                  element.Sort == i + 1 &&
                  element.OffDutyTime.search("次日") > -1
                ) {
                  //跨日的放到下一行
                  if (element.OffDutyHour > 0) {
                    let nextWtd = {
                      SetId: element.SetId,
                      Sort: element.Sort + 1,
                      Name: element.Name,
                      OnDutyHour: 0,
                      OnDutyMinute: element.OnDutyMinute,
                      OffDutyHour: element.OffDutyHour,
                      OffDutyMinute: element.OffDutyMinute,
                      OnDutyTime: element.OnDutyTime,
                      OffDutyTime: element.OffDutyTime,
                      SpanCount: element.OffDutyHour,
                      SpanText: element.SpanText,
                      part: 2
                    };
                    element = nextWtd;
                    that.myWorkTimeData[i + 1].Times.push(nextWtd);
                  }
                  let wtd = {
                    SetId: element.SetId,
                    Sort: element.Sort,
                    Name: element.Name,
                    OnDutyHour: element.OnDutyHour,
                    OnDutyMinute: element.OnDutyMinute,
                    OffDutyHour: 24,
                    OffDutyMinute: element.OffDutyMinute,
                    OnDutyTime: element.OnDutyTime,
                    OffDutyTime: element.OffDutyTime,
                    SpanCount: 24 - element.OnDutyHour,
                    SpanText: element.SpanText,
                    part: 1
                  };
                  element = wtd;
                }
              }
            }
          }
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>
